import React from 'react';
import Footer from '../components/Footer';
import BarraNavegacion from '../components/BarraNavegacion';

function Page404() {
  return (
    <div className="d-flex flex-column min-vh-100"> {/* Added for full height layout */}
      <BarraNavegacion />
      <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center px-3">
        <h1 className="display-1 fw-bold text-primary mb-3">404</h1> {/* Large, bold 404 */}
        <h2 className="mb-4">¡Oops! Página no encontrada</h2>
        <p className="lead mb-4">Parece que la página que buscas no existe o se ha movido.</p>
        <a href="/" className="btn btn-primary btn-lg">Volver a la página principal</a> {/* Clear call to action */}
      </div>
      <Footer />
    </div>
  );
}

export default Page404;